module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appearing main"
  }, [_c('div', {
    staticClass: "main-container white-background"
  }, [_c('div', {
    staticClass: "main-label black-color"
  }, [_vm._v("\n         " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Mot de passe",
      "error-messages": _vm.passwordErrors,
      "blur": "$v.password.$touch()",
      "append-icon": _vm.hiddenPassword ? 'visibility' : 'visibility_off',
      "type": _vm.hiddenPassword ? 'password' : 'text'
    },
    on: {
      "input": function($event) {
        _vm.$v.password.$touch()
      },
      "click:append": function () { return (_vm.hiddenPassword = !_vm.hiddenPassword); }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Mot de passe (confirmation)",
      "error-messages": _vm.passwordConfirmedErrors,
      "blur": "$v.passwordConfirmed.$touch()",
      "append-icon": _vm.hiddenPassword ? 'visibility' : 'visibility_off',
      "type": _vm.hiddenPassword ? 'password' : 'text'
    },
    on: {
      "input": function($event) {
        _vm.$v.passwordConfirmed.$touch()
      },
      "click:append": function () { return (_vm.hiddenPassword = !_vm.hiddenPassword); }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.debouncedSubmit($event)
      }
    },
    model: {
      value: (_vm.passwordConfirmed),
      callback: function($$v) {
        _vm.passwordConfirmed = $$v
      },
      expression: "passwordConfirmed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "submit-block"
  }, [_c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.formValidAndDirty,
      "flat": "",
      "dark": ""
    },
    on: {
      "click": _vm.debouncedSubmit
    }
  }, [_vm._v(_vm._s(_vm.submitButtonText))])], 1)], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.errMsg))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3c75b48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/ActivateUser.vue
// module id = 1215
// module chunks = 1